import {
  EditableFormIdempotencyToken,
  type FeatureRegistry,
  FlowSubmissionIdempotencyToken,
} from '@betterment/js-runtime';

export const featureRegistry: FeatureRegistry = {
  employees: {
    UpdateEmployeeContributionRates: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
  },
  signablePackage: {
    CapturePackageSignature: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
    ForwardSignature: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
    ReclaimPackageSignature: {
      idempotencyToken: EditableFormIdempotencyToken,
    },
  },
  reports: {
    CreateBenefitReport: {
      idempotencyToken: FlowSubmissionIdempotencyToken,
    },
  },
};
